import Creators from './actions';

const { updateNavSidebarVisibility } = Creators;

export default updateNavSidebarVisibility;
